import { useCallback, useEffect } from "react";
import appHistory from "../../../app/appHistory";
import { RouterPaths } from "../../../app/appConstants";
import { Loader } from "../../../components/Loader/Loader";
import {
    OnboardingCongratulationsContainerStyled,
    OnboardingCongratulationsContentStyled,
    OnboardingCongratulationsPageStyled
} from "./styled/OnboardingCongratulationsPageStyled";
import { Button } from "react-bootstrap";
import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import { createStructuredSelector } from "reselect";
import { getOnboardingCompleted, getOnboardingCompleteLoading } from "../../../app/appSelectors";
import { completeOnboardingAction } from "../../../app/appActions";
import { connect } from "react-redux";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

const OnboardingInitialCongratulationsContent = (props) => {
    const {getLangPath} = useLangContext();
    const {pushGtmEvent} = useGTMEvent({module: 'OnboardingTutorialClosePosition'});
    const {completeOnboardingAction, onboardingCompleteLoading, onboardingCompleted} = props;
    useEffect(() => {
        if (!onboardingCompleted) {
            completeOnboardingAction();
        }
    }, [completeOnboardingAction, onboardingCompleted]);

    const handleClick = useCallback(() => {
        pushGtmEvent({event: 'onboarding_click', button: 'GetTheApp'})
        appHistory.push(RouterPaths.mobileDepositBonus);
    }, [pushGtmEvent]);

    if (onboardingCompleteLoading) {
        return <Loader show/>
    }

    return (
            <OnboardingCongratulationsPageStyled>
                <OnboardingCongratulationsContainerStyled>
                    <OnboardingCongratulationsContentStyled>
                        <h1 className="mb-0" dangerouslySetInnerHTML={{__html: getLangPath('onboarding.you_earned')}}/>
                        <p className="mb-0 mt-4"
                           dangerouslySetInnerHTML={{__html: getLangPath('onboarding.continue_practicing')}}/>
                    </OnboardingCongratulationsContentStyled>
                    <Button
                            className="mt-3"
                            size="lg"
                            variant="primary"
                            onClick={handleClick}
                    >
                        {getLangPath('onboarding.go_button')}
                    </Button>
                </OnboardingCongratulationsContainerStyled>
            </OnboardingCongratulationsPageStyled>
    )
}

const mapStateToProps = createStructuredSelector({
    onboardingCompleteLoading: getOnboardingCompleteLoading,
    onboardingCompleted: getOnboardingCompleted,
});

const mapDispatchToProps = {
    completeOnboardingAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingInitialCongratulationsContent)
